// extracted by mini-css-extract-plugin
export var slider = "toggle-module--slider--0124a";
export var toggleContainer = "toggle-module--toggleContainer--dab39";
export var toggleLabel = "toggle-module--toggleLabel--02a45";
export var toggleLabelNonactive = "toggle-module--toggleLabelNonactive--79604";
export var toggleSwitch = "toggle-module--toggleSwitch--8553d";